<app-sidenav-filters
  (containers)="changeContainers($event)"
  [filterContainers]="filterContainers"
  (torn)="changeTorn($event)"
  (unknown)="changeUnknown($event)"
  [filterDevicesTypes]="filterDevicesTypes"
  (devicesTypes)="changeDevicesTypes($event)"
  [filterContainerCategory]="filterContainerCategory"
  (containerCategory)="changeContainerCategory($event)"
></app-sidenav-filters>
<div class="kpi-container">
  <app-header-kpi
    (containers)="changeContainers($event)"
    (torn)="changeTorn($event)"
    (unknown)="changeUnknown($event)"
    [filterContainers]="filterContainers"
    [filterTorn]="filterTorn"
    [filterUnknown]="filterUnknown"
    (devicesTypes)="changeDevicesTypes($event)"
    [filterDevicesTypes]="filterDevicesTypes"
    (containerCategory)="changeContainerCategory($event)"
    [filterContainerCategory]="filterContainerCategory"
  >
  </app-header-kpi>

  <!-- Status Colors Indicator -->
  <div class="kpi-content">
    @if (!loading.stateColors) {
      <app-graph-kpi
        [type]="'colorStatus'"
        [statusIndicators]="statusIndicators"
      ></app-graph-kpi>
    }
    @if (loading.stateColors) {
      <div class="kpi-skeleton">
        <div class="skeleton"></div>
      </div>
    }

    <!-- Battery Indicator -->
    @if (loading.battery) {
      <div class="kpi-skeleton">
        <div class="skeleton"></div>
      </div>
    }
    @if (!loading.battery) {
      <app-graph-kpi
        [type]="'battery'"
        [batteryIndicators]="batteryIndicators"
      ></app-graph-kpi>
    }

    <!-- Alerts Sites Indicator - TMP DISABLE-->
    <!-- <div *ngIf="loading.alertSites" class="kpi-skeleton alert-sites">
    <div class="skeleton"></div>
  </div>
  <div *ngIf="!loading.alertSites" class="kpi-stats-container">
    <div class="kpi-stats-content kpi-last-sites">
      <div class="kpi-stats-header">
        <h1 class="kpi-stats-title">{{ "kpi.alertsBySites" | translate }}</h1>

        <svg-icon class="kpi-stats-icon" [name]="'alert-site'"></svg-icon>
      </div>
      <div class="kpi-stats-body">
        <div class="kpi-stat-overview" *ngFor="let alert of alertSites">
          <h2 class="kpi-stat-title">{{ alert.code }}</h2>
          <p class="kpi-stat-label">{{ alert.label }}</p>
          <h3 class="kpi-stat-count">{{ alert.count }}</h3>
        </div>
        <p *ngIf="!alertSites?.length" class="kpi-stats-empty">
          {{ "kpi.noData" | translate }}
        </p>
      </div>
    </div>
  </div> -->
  </div>
</div>
